module.exports = __webpack_public_path__ + "assets/img/Spark-Systems-Website-w720.05422fe6.jpg";